import { Grid } from "@mui/material";

type BarProps = {
  children: React.ReactNode;
  height?: string;
};

export const Bar = ({ children, height = "auto" }: BarProps) => (
  <Grid container alignItems="center" justifyContent="space-between" wrap="nowrap" sx={{ height }}>
    {children}
  </Grid>
);

type BarItemProps = {
  children: React.ReactNode;
};

export const BarItem = ({ children }: BarItemProps) => (
  <Grid item xs="auto" container alignItems="center">
    {children}
  </Grid>
);
